export const countryList = [
    {label: 'India', value: 'India'},
    {label: 'Singapore', value: 'Singapore'},
    {label: 'USA', value: 'USA'},
];
export const currencyList = [
    {label: 'INR', value: 'INR'},
    {label: 'USD', value: 'USD'},
    {label: 'SGD', value: 'SGD'},
    {label: 'Euro', value: 'Euro'},
]
export const typeOfResponse = [
    { label : 'Static Response' , value : 'static_response' },
    // { label : 'DB Response' , value : 'db_response' },
    // { label : 'API Response' , value : 'api_response' },
]

export const productFeatureResponseType = [
    { label : 'Static Response' , value : 'static_response' },
    { label : 'Dynamic Response' , value : 'dynamic_response' },
]

export const countryCodeList = [
    {label: 'India (+91)', value: '+91'},
    {label: 'Singapore (+65)', value: '+65'},
    {label: 'USA (+1)', value: '+1'},
]

export const followUpDetailsOptions = [
    { label : 'Follow Up Action Name' , value : 'opt_in' },
    { label : 'Closing Utterance' , value : 'closing_utterance' },
    { label : 'Feedback' , value : 'feedback' },
]